module.exports = __webpack_public_path__ + "img/portrait-070.a04c8ba3.jpg";